const NOOP = () => {
	// Do nothing
};

export default NOOP;
